var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[(_vm.obra)?_c('book-simple',{attrs:{"obra":_vm.obra,"type":"full"}}):_vm._e()],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }